var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button-icon',{staticStyle:{"width":"35px"},attrs:{"custom-icon":_vm.value ? 'fa fa-volume-off' : 'fa fa-volume-up',"ghost":""},on:{"on-click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }